import { AddressBase } from '../address-base.model';

export class OwnerRegistrationData {
  address: AddressBase;
  coOwners: Array<{ address: AddressBase }>;

  constructor() {
    this.address = new AddressBase();
  }
}
